export const leadCustomerConstants = { 
    CUSTOMER_SEARCH_SUCCES: 'CUSTOMER_SEARCH_SUCCES',
    CUSTOMER_SEARCH_FAIL: 'CUSTOMER_SEARCH_FAIL',

    CUSTOMER_SELECTED_SUCCES: 'CUSTOMER_SELECTED_SUCCES',
    RESET_LEADCUSTOMER: 'RESET_LEADCUSTOMER'
}